module.exports = require("@cimpress-technology/react-streamline-icons/lib/IconDataTransferHorizontal");